import styled from 'styled-components';

export const CreateBusinessContainer = styled.div`
  display: flex;
  min-height: 100vh;
  background-color: #f8f9fa;
  margin: 0;
  padding: 0;
`;

export const LeftColumn = styled.div`
  flex: 0.4;
  padding: 2rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #ffffff;
  box-shadow: 2px 0 5px rgba(0, 0, 0, 0.1);
  margin: 0;
`;

export const RightColumn = styled.div`
  flex: 0.6;
  padding: 0rem;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0;
`;

export const BenefitsList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 1.5rem 0;
  width: 100%;
  max-width: 350px;

  li {
    display: flex;
    align-items: center;
    margin-bottom: 0.8rem;
    font-size: 1rem;
    color: #333;

    svg {
      margin-right: 0.8rem;
      color: #007bff;
      font-size: 1.2rem;
    }
  }
`;

export const FormWrapper = styled.div`
  width: 100%;
  max-width: 500px;
  background-color: #ffffff;
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  padding: 2rem;

  h1 {
    margin-bottom: 1.5rem;
    text-align: center;
  }

  form {
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
  }
`;

export const FormRow = styled.div`
  display: flex;
  gap: 1rem;
  width: 100%;
`;
